import React, {Component} from 'react';
import {Menu, Tab, Table} from 'semantic-ui-react';
import {Link} from "react-router-dom";
import {withUserContext} from "./ModalContext";

class Schedule extends Component {

    constructor() {
        super();
        this.schedule=[
            {
                date:"11th March",
                data:[
                    {
                        name:"Inaugaration Ceremony",
                        time:'17:00 - 18:00',
                        value: 35,
                    },
                    {
                        name:"Nrityanjali",
                        time:'18:15 - 19:15',
                        value:18 ,
                    },
                    {
                        name:"Campus Idol",
                        time:'19:15 - 20:015',
                        value: 14,
                    },
                    {
                        name:"App Development",
                        time:'20:30 - 21:00',
                        value: 0,
                    },
                    {
                        name:"Web Development",
                        time:'21:00 - 21:30',
                        value: 5,
                    },
                ],
            },
            {
                date:"12th March",
                data:[

                    // {
                    //     name:"Art Attack",
                    //     time:'9:00 - 10:00',
                    //     value: 12,
                    // },

                    {
                        name:"Honeywell Webinar",
                        time:'11:00 - 12:00',
                        value: 38,
                    },
                    // {
                    //     name:"Picelectric",
                    //     time:'12:00 - 13:00',
                    //     value: 19,
                    // },
                    // {
                    //     name:"Meme Exhibition",
                    //     time:'13:00 - 14:00',
                    //     value: 30,
                    // },
                    {
                        name:"Informal QuizHub",
                        time:'13:00 - 14:00',
                        value: 31,
                    },
                    {
                        name:"Code Arduino",
                        time:'13:00 - 16:00',
                        value: 4,
                    },
                    {
                        name:"Shark Tank",
                        time:'14:00 - 16:00',
                        value: 11,
                    },
                    {
                        name:"L&T Industrial Visit",
                        time:'15:00 - 16:00',
                        value: -1,
                    },
                    {
                        name:"Honeywell webinar",
                        time:'16:00 - 17:00',
                        value: 39,
                    },
                    // {
                    //     name:"Infi Quizzes",
                    //     time:'17:00 - 18:00',
                    //     value: 32,
                    // },
                    {
                        name:"Hackathon",
                        time:'17:00 - 23:59',
                        value: 10,
                    },
                    {
                      name:'Social Cause',
                      time:'17:00 - 18:00',
                        value:-1,
                    },
                    {
                        name:"Suhani Shah Show",
                        time:'17:30 - 19:00',
                        value: 33,
                    },
                    {
                        name:"Talk Show with Shriya Pilgaonkar",
                        time:'19:00 - 20:15',
                        value: 34,
                    },
                    {
                        name:"Break Free",
                        time:'20:30 - 21:30',
                        value: 13,
                    },

                ],
            },
            {
                date:"13th March",
                data:[
                    {
                        name:"Circuit Building",
                        time:'9:00 - 12:00',
                        value: 3,
                    },
                    // {
                    //     name:"Doodle Art",
                    //     time:'10:00 - 11:00',
                    //     value: 15,
                    // },
                    {
                        name:"L&T Webinar",
                        time:'11:00 - 12:00',
                        value: -1,
                    },
                    {
                        name:"Standup Competition",
                        time:'11:15 - 12:15',
                        value: 20,
                    },
                    {
                        name:"DeepN",
                        time:'12:00 - 23:59',
                        value: 8,
                    },
                    {
                        name:"Yocket Webinar",
                        time:'13:00 - 14:00',
                        value: -1,
                    },

                    {
                        name:"Valorant Final",
                        time:'15:00 - 16:00',
                        value: 29,
                    },
                    {
                        name:"Social Cause - Insta Live",
                        time:'16:00 - 15:00',
                        value: 37,
                    },
                    {
                        name:"CAD Pro",
                        time:'15:00 - 18:00',
                        value: 1,
                    },
                    {
                        name:"Mr And Ms Elan",
                        time:'16:00 - 18:00',
                        value: 26,
                    },
                    {
                        name:"Comedy Night with Zakir Khan",
                        time:'17:30 - 19:00',
                        value: 32,
                    },
                ],
            },
            {
                date:"14th March",
                data:[
                    {
                        name:"Enigma",
                        time:'9:00 - 11:00',
                        value: 2,
                    },
                    {
                        name:"Filmfare Fiesta",
                        time:'11:15 - 12:15',
                        value: 16,
                    },
                    {
                        name:"Machina Doctrina",
                        time:'11:00 - 15:00',
                        value: 7,
                    },
                    {
                        name:"Paper Presentation Round 2",
                        time:'13:00 - 16:00',
                        value: 9,
                    },
                    {
                        name:"Proquest",
                        time:'15:00 - 18:00',
                        value: 6,
                    },
                    {
                        name:"Glitz and Glamour",
                        time:'16:00 - 17:15',
                        value: 17,
                    },
                    {
                        name:"Indie Rock - Naalayak",
                        time:'18:00 - 19:00',
                        value: 36,
                    },
                    // {
                    //     name:"Winners Announcement",
                    //     time:'19:00 - 21:00',
                    //     value: -1,
                    // },
                ],
            },

        ]
    }

    render() {
        return (
            <div className={'schedule'}>
                <Tab menu={'secondary'} panes={
                    this.schedule.map(item=>{
                        return {
                            menuItem:<Menu.Item onClick={()=>{
                                this.setState({selected_tab:'techy'});
                            }} className={''}>{item.date}</Menu.Item> ,
                            render: () => (
                                <Tab.Pane>
                                    <Table columns={2} compact={'false'} basic={true}>
                                        <Table.Body>
                                            {item.data.map(event=>{
                                                return (
                                                    <Link to={`/events/${event.value}`} onClick={
                                                    ()=> this.props.setShowSchedule(false)
                                                    }>
                                                        <Table.Row>
                                                            <Table.Cell >{event.name}</Table.Cell>
                                                            <Table.Cell >{event.time}</Table.Cell>
                                                        </Table.Row>
                                                    </Link>
                                                )
                                            })}
                                        </Table.Body>
                                    </Table>
                                </Tab.Pane>
                            )
                        }
                    })
                }/>
            </div>
        );
    }
}

export default withUserContext(Schedule);